import React from "react";
import "./style.scss";
const Button = ({
  width,
  height,
  isDisabled,
  handleClick,
  text,
  showIcon,
  iconImage,
}) => {
  return (
    <button
      style={{ width: width, height: height }}
      disabled={isDisabled}
      onClick={handleClick}
      className={`commonBtn ${
        isDisabled ? "button_disabled" : "button_active"
      }`}
    >
      {text}
      {showIcon && <img src={iconImage} alt="" />}
    </button>
  );
};
export default Button;
